// Resolve window.WX (public/wxchange-config.js) into concrete values. A
// placeholder the Helm init container left alone, or an empty value, means
// "use the default" — that is the plain `pnpm dev` posture.

const isPlaceholder = (v) => typeof v !== "string" || v === "" || /^__[A-Z_]+__$/.test(v);

export function resolveConfig(WX = {}) {
  const pick = (v, dflt) => (isPlaceholder(v) ? dflt : v);
  const mode = pick(WX.AUTH_MODE, "none");
  return {
    apiBase: (pick(WX.API_BASE, "") || "").replace(/\/+$/, ""),
    authMode: mode === "keycloak" ? "keycloak" : "none",
    keycloakUrl: pick(WX.KEYCLOAK_URL, ""),
    clientId: pick(WX.KEYCLOAK_CLIENT_ID, "wxchange-demo-chaos"),
    realm: pick(WX.KEYCLOAK_STAFF_REALM, "staff"),
    map: WX.MAP || { center: [30, -40], zoom: 3 },
  };
}
